import Utility from '../../../util/utilityfunctions';

export default (state, action, chunk, prop, normalizer, isRelate = true, sortBy = 'name') => {
	let updatedData = [...(state?.[chunk]?.[prop] ?? [])];
	if (isRelate && normalizer) {
		const filterIt = ({id}) => id === action?.item?.id;
		const itExists = state?.[chunk]?.[prop]?.some(filterIt);
		if (!itExists)
			updatedData = Utility.sortAlphaNumericImmutable([...updatedData, ...[{...action?.item}].map(normalizer)], sortBy);
	} else {
		updatedData = updatedData.filter(({id}) => id !== action?.item?.id);
	}

	return {
		...state,
		[chunk]: {
			...state?.[chunk],
			[prop]: updatedData
		}
	};
};
